import React from 'react';
import cx from 'classnames';

import BaseButton from '@magoosh/lib/button/base';
import { PrimaryButton } from '@magoosh/lib/button';

import { PaymentMethod } from '@payments/types';

import ApplePayIcon from '@payments/assets/apple_pay_dark.svg';
import GooglePayIcon from '@payments/assets/google_pay_dark.svg';
import style from '@payments/style.module.scss';

interface Props {
  isPaidOrder: boolean;
  isSubmitting: boolean;
  onClick: (any) => any;
  paymentMethod: PaymentMethod;
  paymentRequestMethod: string;
}

const SubmitPaymentButton: React.FC<Props> = (props) => {
if (props.paymentRequestMethod === 'Google Pay' && props.paymentMethod == PaymentMethod.STRIPE_PAYMENT_REQUEST) {
    return (
      <BaseButton
        className={cx(style.googlePayButton, style.btnBlockOnMobile, 'u-padding-H-xl')}
        onClick={props.onClick}
        submitting={props.isSubmitting}
        type="submit"
      >
        Complete Order With <img src={GooglePayIcon} alt="Google Pay" style={{ height: 20 }} />
      </BaseButton>
    )
  } else if (props.paymentRequestMethod === 'Apple Pay' && props.paymentMethod == PaymentMethod.STRIPE_PAYMENT_REQUEST) {
    return (
      <BaseButton
        className={cx(style.applePayButton, style.btnBlockOnMobile, 'u-padding-H-xl')}
        onClick={props.onClick}
        submitting={props.isSubmitting}
        type="submit"
      >
        Complete Order With <img src={ApplePayIcon} alt="Apple Pay" style={{ height: 20 }} />
      </BaseButton>
    )
  } else {
    const submitButtonName = props.isPaidOrder ? 'Complete Order' : 'Sign Up';

    return (
      <PrimaryButton
        className={cx(style.btnBlockOnMobile, 'u-padding-H-xl')}
        onClick={props.onClick}
        submitting={props.isSubmitting}
        type="submit"
      >
        {props.paymentMethod == PaymentMethod.STRIPE ? submitButtonName : 'Continue to Payment'}
      </PrimaryButton>
    );
  }
};

export default SubmitPaymentButton;
